<template>
  <!-- eslint-disable  -->
  <div>
    <!-- TODO: Remove this conditional once API sends proper data -->
    <div v-if="!isLegacyData" class="row">
      <div v-for="(section, i) in Object.keys(coverageSummary)" :key="i" class="col-md-12">
        <div v-if="section != 'vehicleCoverages'">
          <div class="section-label">{{ humanize(section) }}</div>
          <div v-for="(row, j) in coverageSummary[section]" :key="j" class="row">
            <div class="row-label col-md-6">{{ row.label }}</div>
            <div class="row-value col-md-6 text-right">{{ row.text }}</div>
          </div>
        </div>
        <div class="row" v-else>
          <div v-for="(row, j) in coverageSummary[section]" :key="j" class="col-6">
            <div class="row no-gutters pt-4">
              <div class="section-label col-md-12">{{ row.label }}</div>
              <div v-for="(childrow, l) in row.coverageDetails" :key="l" class="col-md-12">
                <div class="row no-gutters">
                  <div class="row-label col-md-6"> {{ childrow.label }} </div>
                  <div class="row-value col-md-6 text-right">{{ childrow.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: ['carrier'],
  data() {
    return {
      childCoverageForSelectedSection: [],
    };
  },
  computed: {
    // TODO: Remove legacy data check once API sends proper data
    isLegacyData() {
      let isLegacyData = false;

      Object.keys(this.coverageSummary).forEach((prop) => {
        if (!Array.isArray(this.coverageSummary[prop])) {
          isLegacyData = true;
        }
      });

      return isLegacyData;
    },
    summaryId() {
      return `collapse-carrier-${this.carrier.carrier_id}`;
    },
    coverageSummary() {
      if (this.carrier && this.carrier.coverageSummary) {
        for (var key in this.carrier.coverageSummary) {
          if (this.carrier.coverageSummary[key].length === 0) {
            delete this.carrier.coverageSummary[key];
          }
        }
        return this.carrier.coverageSummary;
      }
      return {};
    },
  },

  methods: {
    /**
     * (Modification of Bootstrap Vue's usage at
     * https://github.com/bootstrap-vue/bootstrap-vue/blob/ee1c10eb03003ab69ba137a8288952d1ddb67bab/src/utils/startcase.js )
     *
     * Converts a string, including strings in camelCase or snake_case, into Start Case (a variant
     * of Title Case where all words start with a capital letter), it keeps original single quote
     * and hyphen in the word.
     *
     * Copyright (c) 2017 Compass (MIT)
     * https://github.com/UrbanCompass/to-start-case
     * @author Zhuoyuan Zhang <https://github.com/drawyan>
     * @author Wei Wang <https://github.com/onlywei>
     *
     * @param {String} string
     * @returns {String}
     */
    humanize(string) {
      /* eslint-disable prefer-template */

      return string
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, (str, $1, $2) => $1 + ' ' + $2)
        .replace(/(\s|^)(\w)/g, (str, $1, $2) => $1 + $2.toUpperCase());
    },
    formatValue(string) {
      return string.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    },
  },
};
</script>

<style lang="scss" scoped>
$muted: #dbe7f3;

label {
  background: $muted;
}

.carrier-coverage-summary {
  margin-top: 2px;
}

.home label {
  background: $var-home-bg;
}

.renters label {
  background: $var-renter-bg;
}

.condo label {
  background: $var-color-condo-nav-bg;
}

label,
.toggle-icon {
  display: block;
  cursor: pointer;
}

.toggle-icon {
  float: right;
}

.toggle-icon .toggle-up {
  display: inline-block;
}

.toggle-icon .toggle-down {
  display: none;
}

.collapsed {
  .toggle-icon .toggle-down {
    display: inline-block;
  }

  .toggle-icon .toggle-up {
    display: none;
  }
}

.section-label {
  border-bottom: 2px solid $var-alert-primary;
  font-weight: 600;
}

.row {
  line-height: 2em;
}

.row-label {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/AutoCarrierCoverageSummary.vue?c4df609c